import React, { useState, useRef, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import SinavModal from "./SinavModal";
import axios from "axios";
import "../styles/EgitimStep.css";

const LegacyEgitimStep = ({ egitim, onClose }) => {
  const navigate = useNavigate();

  const [aktifAdim, setAktifAdim] = useState(0);
  const [baslangicSaniyesi, setBaslangicSaniyesi] = useState(0);
  const [videoIzlendi, setVideoIzlendi] = useState(false);
  const [showSinav, setShowSinav] = useState(false);
  const [baslaButonYazi, setBaslaButonYazi] = useState(
    egitim?.hasExam === false ? "Eğitimi Tamamla" : "Sınava Başla"
  );
  const [ilkYuklemeTamam, setIlkYuklemeTamam] = useState(false);

  // KVKK özel state'leri
  const [showKvkkPopup, setShowKvkkPopup] = useState(false);
  const [kvkkMetinOkundu, setKvkkMetinOkundu] = useState(false);
  const [kvkkOnayDegeri, setKvkkOnayDegeri] = useState("");
  const [kvkkOnayTamamlandi, setKvkkOnayTamamlandi] = useState(false);
  const [showKvkkUyari, setShowKvkkUyari] = useState(false);
  const [showKvkkVideoUyari, setShowKvkkVideoUyari] = useState(false);

  const videoRef = useRef(null);
  const stepRefs = useRef([]);

  const moduller = Array.isArray(egitim?.moduller) ? egitim.moduller : [];
  const aktifModul = moduller[aktifAdim];
  const kvkkMi = egitim?.id === 5;

  const sinavaBaslaAktif = !kvkkMi || (videoIzlendi && kvkkOnayTamamlandi);


  // --- API: mevcut ilerlemeyi getir ---
  const kontrolEt = useCallback(async () => {
    const token = localStorage.getItem("token");
    const modulId = egitim?.id || 1;

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/Isg/getir?modulId=${modulId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data) {
        const nextIndex = Math.max(
          0,
          Math.min(
            res.data.videoId ? res.data.videoId - 1 : 0,
            Math.max(0, moduller.length - 1)
          )
        );
        setAktifAdim(nextIndex);
        setBaslangicSaniyesi(res.data.saniye || 0);
        setBaslaButonYazi(
          res.data.basariDurumu
            ? "Tamamlandı"
            : egitim?.hasExam === false
              ? "Eğitimi Tamamla"
              : "Sınava Başla"
        );
      }
    } catch (err) {
      if (err.response?.status === 404) {
        setBaslaButonYazi(
          egitim?.hasExam === false ? "Eğitimi Tamamla" : "Sınava Başla"
        );
        try {
          await axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/api/Isg/ekle?modulId=${modulId}`,
            {},
            { headers: { Authorization: `Bearer ${token}` } }
          );
        } catch (postErr) {
          console.error("Kayıt oluşturulamadı:", postErr);
        }
      } else {
        console.error("Kontrol Et hatası:", err);
      }
    }
  }, [egitim?.id, moduller.length, egitim?.hasExam]);

  // --- API: saniye güncelle ---
  const videoTakip = useCallback(async () => {
    const token = localStorage.getItem("token");
    const modul = egitim?.id || 1;
    const videoId = aktifAdim + 1;
    const saniye = Math.floor(videoRef.current?.currentTime || 0);

    try {
      await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/Isg/guncelle`,
        { modul, videoId, saniye },
        { headers: { Authorization: `Bearer ${token}` } }
      );
    } catch (err) {
      console.error("Takip hatası:", err);
    }
  }, [egitim?.id, aktifAdim]);

  // --- ilk yüklemede ilerlemeyi al ---
  useEffect(() => {
    kontrolEt();
  }, [kontrolEt]);

  // --- modül sayısı değişirse aktif indeksi clamp’le ---
  useEffect(() => {
    setAktifAdim((prev) => {
      const maxIdx = Math.max(0, moduller.length - 1);
      return Math.min(Math.max(prev, 0), maxIdx);
    });
  }, [moduller.length]);

  // --- periyodik progress (yalnızca HTML5 video) ---
  useEffect(() => {
    const int = setInterval(() => {
      if (videoRef.current && !videoRef.current.paused) videoTakip();
    }, 5000);
    return () => clearInterval(int);
  }, [aktifAdim, videoTakip]);

  // --- step kutularına auto-scroll ---
  useEffect(() => {
    if (stepRefs.current[aktifAdim]) {
      stepRefs.current[aktifAdim].scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [aktifAdim]);

  // --- ileri sarma kısıtı ---
  useEffect(() => {
    const int = setInterval(() => {
      if (videoRef.current) {
        videoRef.current.lastAllowedTime = videoRef.current.currentTime;
      }
    }, 10000);
    return () => clearInterval(int);
  }, []);

  const handleSeeking = useCallback(() => {
    if (!ilkYuklemeTamam) return;
    const video = videoRef.current;
    if (!video) return;

    const allowed = video.lastAllowedTime || 0;
    const current = video.currentTime;
    if (current > allowed + 1) {
      video.currentTime = allowed;
    }
  }, [ilkYuklemeTamam]);

  const handleDevam = useCallback(() => {
    if (aktifAdim < moduller.length - 1) {
      setAktifAdim((p) => p + 1);
      setVideoIzlendi(false);
      setBaslangicSaniyesi(0);

      if (kvkkMi) {
        setShowKvkkPopup(false);
        setKvkkMetinOkundu(false);
        setKvkkOnayDegeri("");
        setKvkkOnayTamamlandi(false);
      }
    }
  }, [aktifAdim, moduller.length, kvkkMi]);

  const handleGeri = useCallback(() => {
    if (aktifAdim > 0) {
      setAktifAdim((p) => p - 1);
      setVideoIzlendi(false);
      setBaslangicSaniyesi(0);

      if (kvkkMi) {
        setShowKvkkPopup(false);
        setKvkkMetinOkundu(false);
        setKvkkOnayDegeri("");
        setKvkkOnayTamamlandi(false);
      }
    }
  }, [aktifAdim, kvkkMi]);

  const handleKvkkScroll = useCallback((e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    if (scrollTop + clientHeight >= scrollHeight - 5) {
      setKvkkMetinOkundu(true);
    }
  }, []);

  const handleKvkkKeyDown = useCallback((e) => {
    const key = e.key.toLowerCase();

    if ((e.ctrlKey || e.metaKey) && ["c", "x", "a", "p", "s"].includes(key)) {
      e.preventDefault();
    }

    if (key === "printscreen") {
      e.preventDefault();
    }
  }, []);

  const handleKvkkPopupOnayla = useCallback(() => {
    if (!kvkkMetinOkundu) return;

    setKvkkOnayDegeri("okudum");
    setKvkkOnayTamamlandi(true);
    setShowKvkkPopup(false);
  }, [kvkkMetinOkundu]);

  const handleSinavBasla = useCallback(async () => {
    try {
      await videoTakip();
    } catch { }

    if (egitim?.hasExam === false) {
      handleSinavBitir(true);
      return;
    }

    if (kvkkMi && !sinavaBaslaAktif) {
      setShowKvkkUyari(true);
      return;
    }
    setShowSinav(true);
  }, [videoTakip, egitim?.hasExam, kvkkMi, sinavaBaslaAktif]);

  const handleSinavBitir = useCallback(
    (basarili) => {
      setShowSinav(false);
      if (basarili) {
        setBaslaButonYazi("Tamamlandı");
        onClose();
        navigate("/profil", { state: { modulTamamlandi: egitim.id } });
      } else {
        setBaslaButonYazi("Sınavı Tekrarla");
      }
    },
    [egitim?.id, navigate, onClose]
  );

  return (
    <div className="egitim-step-overlay">
      <div className="egitim-step-container">
        <button className="egitim-step-close" onClick={onClose}>
          ✖
        </button>

        <div className="egitim-step-bar">
          {moduller.map((modul, index) => (
            <div
              key={index}
              ref={(el) => (stepRefs.current[index] = el)}
              className={`step-box ${index === aktifAdim ? "aktif" : index < aktifAdim ? "tamamlandi" : ""
                }`}
            >
              {modul.ad}
            </div>
          ))}
        </div>

        <div className="egitim-step-video">
          <video
            ref={videoRef}
            width="100%"
            controls
            preload="auto"
            muted
            playsInline
            webkit-playsinline="true"
            onEnded={() => setVideoIzlendi(true)}
            onLoadedMetadata={() => {
              const hedef = Number(baslangicSaniyesi) || 0;
              const video = videoRef.current;
              if (video && hedef > 0) {
                let tries = 0;
                const iv = setInterval(() => {
                  if (video.readyState >= 1) {
                    video.currentTime = hedef;
                    clearInterval(iv);
                    setIlkYuklemeTamam(true);
                  }
                  tries++;
                  if (tries > 20) {
                    clearInterval(iv);
                    setIlkYuklemeTamam(true);
                  }
                }, 200);
              } else {
                setIlkYuklemeTamam(true);
              }
            }}
            onSeeking={handleSeeking}
            key={aktifModul?.video || `m-${aktifAdim}`}
          >
            <source src={aktifModul?.video} type="video/mp4" />
          </video>
        </div>

        {kvkkMi && aktifAdim === moduller.length - 1 && (
          <div className="kvkk-ayri-popup-tetik">
            <div
              className={`kvkk-onay-satiri ${videoIzlendi ? "aktif" : "pasif"}`}
              onClick={() => {
                if (!videoIzlendi) {
                  setShowKvkkVideoUyari(true);
                  return;
                }

                if (!kvkkOnayTamamlandi) {
                  setShowKvkkPopup(true);
                }
              }}
            >
              <label className="kvkk-onay-checkbox-label">
                <input
                  type="checkbox"
                  checked={kvkkOnayTamamlandi}
                  readOnly
                />
                <span>
                  KVKK Aydınlatma Metni'ni okudum, anladım ve onaylıyorum.
                </span>
              </label>
            </div>
          </div>
        )}
        <div className="egitim-step-buttons three-column">
          {aktifAdim > 0 ? (
            <button className="geri-btn" onClick={handleGeri}>
              Geri Dön
            </button>
          ) : (
            <div style={{ width: "100px" }} />
          )}

          {aktifAdim === moduller.length - 1 ? (
            <button
              className={`sinav-btn center ${baslaButonYazi === "Tamamlandı" || !videoIzlendi || (kvkkMi && !sinavaBaslaAktif)
                ? "pasif-gorunum"
                : ""
                }`}
              onClick={handleSinavBasla}
              disabled={baslaButonYazi === "Tamamlandı" || !videoIzlendi}
            >
              {baslaButonYazi}
            </button>
          ) : (
            <div style={{ width: "100px" }} />
          )}

          {aktifAdim < moduller.length - 1 ? (
            <button
              className="devam-btn"
              onClick={handleDevam}
              disabled={!videoIzlendi}
            >
              Devam Et
            </button>
          ) : (
            <div style={{ width: "100px" }} />
          )}
        </div>
      </div>

      {showSinav && (
        <SinavModal
          onKapat={() => setShowSinav(false)}
          onBitir={handleSinavBitir}
          aktifModul={egitim.id}
          kartId={egitim?.id}
        />
      )}

      {showKvkkUyari && (
        <div className="kvkk-uyari-overlay">
          <div className="kvkk-uyari-popup">
            <div className="kvkk-uyari-icon">!</div>
            <p>Sınava başlamadan önce KVKK Aydınlatma Metni'ni okuyup onaylamalısınız.</p>
            <button onClick={() => setShowKvkkUyari(false)}>Tamam</button>
          </div>
        </div>
      )}

      {showKvkkVideoUyari && (
        <div className="kvkk-uyari-overlay">
          <div className="kvkk-uyari-popup">
            <div className="kvkk-uyari-icon">!</div>
            <p>KVKK metnini görüntülemeden önce videoyu tamamlamalısınız.</p>
            <button onClick={() => setShowKvkkVideoUyari(false)}>Tamam</button>
          </div>
        </div>
      )}

      {showKvkkPopup && (
        <div className="kvkk-popup-overlay">
          <div className="kvkk-popup">
            <button
              type="button"
              className="kvkk-popup-close"
              onClick={() => setShowKvkkPopup(false)}
            >
              ✖
            </button>

            <h3 className="kvkk-popup-title">KVKK Aydınlatma Metni</h3>

            <div
              className="kvkk-popup-metin"
              onScroll={handleKvkkScroll}
              onContextMenu={(e) => e.preventDefault()}
              onKeyDown={handleKvkkKeyDown}
              tabIndex={0}
            >
              <p className="kvkk-baslik-merkez">
                <strong>Musa Dengiz Tekstil Sanayi ve Ticaret Limited Şirketi</strong>
              </p>

              <p className="kvkk-baslik-merkez kvkk-alt-baslik">
                <strong>Çalışan Gizlilik, Bilgi Güvenliği ve Kişisel Verilerin Korunması Taahhütnamesi</strong>
              </p>

              <p><strong>1. Gizlilik</strong></p>

              <p>1.1. Musa Dengiz Tekstil Sanayi ve Ticaret Limited Şirketi ("Fulla Moda ”) ile akdettiğim
                iş sözleşmesi ve/veya diğer her türlü ilişki sebebiyle, Fulla Moda’nın tarafıma aktardığı,
                erişimime imkan tanıdığı veya bir şekilde öğrendiğim ya da denetim amacıyla veya başka
                suretle tarafıma bırakılan; Fulla Moda’ya veya tedarikçi-sağlayıcılarına ve Fulla Moda
                ile ticari ilişkide olan sair üçüncü kişiler ile tüm bu sayılanların özellikle çalışanlarına,
                temsilcilerine, müşterilerine yahut diğer ilgililerine ait; her türlü belge, veri, yazışma,
                ticari defter: kayıt, suret, ekipman, işlem, yöntem, kavram, teknik, know-how, çalışma,
                bulgu, buluş, tarif, reçete, metot, fikir, iş, sistem, patent, telif hakkı, uygulama,
                kaynak kodu, yazılım, fikri ve sınai hak, marka, proje, tasarım, eskiz, fotoğraf, plan,
                çizim, teçhizat, numune, rapor, fiyat listesi, gelişme aşamasındaki çalışma, proses,
                pazarlama planı, ürün ve hizmet planı, teknik plan, iş stratejisi, stratejik ittifak ve
                ortaklara ilişkin bilgi, mali bilgi, personel bilgisi, müşteri listesi, şartname,
                potansiyel ve gerçek müşterilerin kimliği, tedarikçilere ilişkin bilgi, istatistiki bilgi,
                her türlü yenilik ile Fulla Moda’nın faaliyetleri, görüşleri, ilgili teknik ve/veya ticari
                bilgileri, ticari marka, ticari sır gibi sözlü, yazılı veya elektronik formattaki her
                türlü bilginin "Gizli Bilgi” olduğunu biliyorum.
              </p>

              <p>
                1.2. Görevim sebebiyle bildirilecek ve/veya öğreneceğim ve/veya ulaşabileceğim veya
                Fulla Moda’nın herhangi bir surette anlaşmalı/ilişkili olduğu kişi ve kuruluşların
                müşterilerine ait, başta ad, soyadı, cinsiyet, adres, telefon, e-posta adresi,
                konum bilgileri ve alışveriş bilgileri olmak üzere her türlü kişisel bilgileri
                Fulla Moda’nın ilişki/bağlantı içerisinde bulunduğu özel-resmi kişi ve kuruluşlara ait
                diğer bilginin ve bu kişi-kuruluşlarla Fulla Moda arasındaki yazılı-sözlü, mali-gayri
                mali anlaşma uygulama bilgilerini, velhasıl, Fulla Moda’nın, herhangi bir surette ilişkili
                olduğu kişi, kuruluşlara ait bilgiler ile tüm bunların müşterilerine ait bütün bilgilerin
                de “Gizli Bilgi” olduğunu ve bu taahhütnamedeki yükümlülüklerim kapsamında bulunduğunu kabul,
                beyan ve taahhüt ederim.
              </p>

              <p>
                1.3. Çalışmakta olduğum Fulla Moda’nın faaliyetlerinin yürütülmesi sırasında gerek bu
                faaliyetlerle ilgili olan gizli bilgi ve belgelerin, gerekse Fulla Moda’nın faaliyetlerinin
                icrası için sözleşme ilişkisi içinde bulunduğu kurum ve kuruluşlar ile üçüncü şahıslar
                hakkında elde edilen ve ileride elde edilecek her türlü gizli bilgiyi herhangi bir kişi veya
                kurum veya kuruluşa sözlü veya yazılı olarak yahut elektronik iletişim araçları vasıtasıyla ya
                da herhangi bir iletişim yöntemi kullanarak paylaşmamayı ve/veya açıklamamayı; Fulla Moda’nın ve
                bağlı olduğu işyerlerinin de dâhil olduğu intranet, iç yazışma ya da e-posta ortamında gelen bilgi
                ve belgeleri de paylaşmamayı ve/veya açıklamamayı kabul, beyan ve taahhüt ederim.
              </p>

              <p>
                1.4. Görevim esnasında temas ettiğim tüm gizli bilgileri süresiz olarak gizli tutmayı,
                korumayı, üçüncü kişilerle herhangi bir şekilde paylaşmamayı ve/veya açıklamamayı,
                doğrudan ya da dolaylı olarak iş amaçları dışında kullanmamayı, şahsi çıkar amacıyla ya da
                herhangi bir mevzuata aykırı şekilde manipüle etmemeyi veya herhangi bir ortama aktarmamayı,
                herhangi bir vasıta ile şirket dışına çıkartmamayı, iş amaçlı kullanım ile sınırlanan ve
                Fulla Moda tarafından şahsıma tahsis edilen bilgisayar ve e-posta dışında taşınabilir
                herhangi bir araç içerisine aktarmamayı, kopyalamamayı, çoğaltmamayı, bunlarla sınırlı
                olmaksızın başka herhangi bir amaçla erişime mümkün hale getirmemeyi ve bu gizli bilgilerin
                herhangi bir şekilde ifşa olması riski ile karşılaşırsam Fulla Moda bilgiislem@fulla.com.tr
                mail adresine mail göndermek suretiyle) derhal bilgilendirmeyi, gecikmesinde sakınca bulunan
                hallerde önlem almayı kabul, beyan ve taahhüt ederim.
              </p>

              <p>
                1.5. Gizli bilgi içeren her türlü materyali, Fulla Moda ile akdettiğim iş sözleşmesinin sona
                ermesi halinde veya sözleşme süresince Fulla Moda’nın talebi üzerine Fulla Moda’ya
                iade edeceğimi ve bu mümkün olmazsa imha edeceğimi kabul, beyan ve taahhüt ederim.
              </p>

              <p><strong>2. Bilgi Güvenliği</strong></p>

              <p>
                2.1. Tarafıma tahsis edilen veya edilecek e-posta hesabı, bilgisayar,
                tablet, akıllı telefon veya benzer herhangi bir elektronik araçta bulunan
                sistem, uygulama veya yazılımlarının kullanılmasını sağlamak üzere şahsıma
                özel olarak oluşturulan ve teslim aldıktan sonra derhal güçlü bir şifreyle
                ( kullanılan son 3 paroladan farklı, minimum 8 karakter, içerisinde sayı
                ve özel karakter barındıran bir parola ile) değiştirmekle yükümlü olduğum
                şifremin veya şifrelerimin saklanması ve korunmasından bizzat sorumlu olduğumu,
                her ne şekilde olursa olsun bunları başkası ile paylaşmayacağımı ve başkasına
                kullandırmayacağımı, güvenli kullanım açısından en geç 180 gün süreyle olmak üzere
                periyodik aralıklarla şifreleri güncelleyeceğimi, sorumluluğumda olan şifre, bilgi ve
                belgelerin çalınmasına karşı her türlü gerekli önlemlerini alacağımı; söz konusu şifremin
                ve/veya şifrelerimin kendi kusurum nedeniyle başkaları tarafından kullanılması, sistemde
                işlem yapılması, teslim aldığım şifre ve/veya şifrelerin tarafımca değiştirilmemesi halinde
                doğacak tüm sorumluluğun tarafıma ait olacağını kabul, beyan ve taahhüt ederim.
              </p>

              <p>
                2.2.	Tarafıma tahsis edilen veya edilecek e-posta hesabı, bilgisayar, tablet,
                akıllı telefon veya benzer herhangi bir elektronik aracı, kişisel amaçlarla kullanmamın
                yasak olduğunu, bunları yalnızca iş amaçlarıyla kullanabileceğimi, dolayısıyla bunlar
                üzerinde şahsıma veya üçüncü kişilere ait işle ilgili olmayan herhangi bir kişisel
                veriyi barındırmayacağımı kabul, beyan ve taahhüt ederim.

              </p>

              <p>
                2.3.	Görevim esnasında internet üzerinden dosya paylaşımı yapan web sitelerini
                (Google drive, wetransfer, yandex disk, mega upload, rapidshare vb.) veya
                uygulamaları ile anlık iletişim kurmayı sağlayan program, yazılım veya uygulamaları
                (WhatsApp, Telegram, Signal vb.) kullanarak işle ilgili
                herhangi bir bilgi veya belge paylaşımı yapmayacağımı kabul, beyan ve taahhüt ederim.
              </p>

              <p>
                2.4.	İnternet ve benzeri herhangi bir ağ üzerinden eriştiğim web sitesi,
                e-postalar ve sair bilgi sistemleri üzerinde gerçekleştirdiğim aktiviteler ile
                ilgili tüm kayıtların mevzuat ile ilgili içtihatların izin verdiği şekilde ve
                inceleme konusu ile sınırlı ve ölçülü olmak kaydıyla çalıştığım sürece ve işten
                ayrıldıktan sonra dahi Fulla Moda tarafından saklanabileceğini, gerektiğinde tarafıma ayrıca
                bildirim yapılmaksızın incelenebileceğini ve denetlenebileceğini kabul, beyan ve taahhüt ederim.
              </p>

              <p>
                2.5.	Fulla Moda’nın dilediği zaman elektronik iletişim ve bilgi işleme araçlarının
                kullanımını mevzuata ve şirket kurallarına uygunluk açısından ve mevzuat ile ilgili
                içtihatların izin verdiği şekilde ve inceleme konusu ile sınırlı ve ölçülü olmak kaydıyla
                tarafıma ayrıca bildirim yapılmaksızın inceleme hakkını haiz olduğunu, ayrıca bu araçlar ile
                gerçekleştirilen aktivitelerle ilgili bilgileri, mevzuat çerçevesinde yetkili kılınan kurumlarla,
                çalışanların izni olmaksızın paylaşma  hakkını saklı tuttuğunu kabul, beyan ve taahhüt ederim.
              </p>

              <p>
                2.6.	Fulla Moda veya müşterilerine ait saklanan, işlenen, iletilen, ortadan kaldırılan her
                türlü bilginin ve kullanılan veri tabanının, elektronik dosya, yazılım, bilgisayar donanımı,
                iletişim araçları vb. bilgi sistemlerinin tehditlere karşı korunabilmesi ve güvenliğinin
                sağlanabilmesi
                için gereken önlemleri alacağımı ve alınan önlemlere uyacağımı kabul, beyan ve taahhüt ederim.
              </p>

              <p>
                2.7.	Tarafıma tahsis edilen veya edilecek e-posta hesabı, bilgisayar, tablet,
                akıllı telefon veya benzer herhangi bir elektronik aracı, Fulla Moda ile akdettiğim iş
                sözleşmesinin sona ermesi halinde derhal kullanmayı
                sona erdireceğimi ve bunları Fulla Moda’ya iade edeceğimi kabul, beyan ve taahhüt ederim.
              </p>

              <p><strong>3. Kişisel Verilerin Korunması</strong></p>

              <p>
                3.1.	Görevim esnasında, yazılı ya da sözlü, her ne şekilde olursa olsun öğrendiğim
                yahut tarafıma açıklanan, Fulla Moda çalışanına, temsilcisine veya müşterisine yahut
                tedarikçilerine, iş ortaklarına, danışmanlarına ya da bunların çalışanlarına ya da Fulla Moda
                ile bağlantılı sair üçüncü kişilere ait; Fulla Moda veri tabanlarında, dosya sunucularında ve
                portallarında elektronik olarak bulunan yahut herhangi bir yerde basılı olarak tutulan kişisel
                verileri (gerçek bir kişiye ilişkin olan ve tek başına yahut başka verilerle birlikte
                ilişkin olduğu kişinin belirlenmesini mümkün kılan her türlü veri) ve bunlarla sınırlı
                olmaksızın herhangi bir tür kişisel veriyi (tamamı birlikte "Kişisel Veri" olarak
                tanımlanacaktır) görevim gerektirmediği
                sürece toplamayacağımı, işlemeyeceğimi, aktarmayacağımı ve bunlara erişmeyeceğimi
              </p>

              <p>
                3.2.	Görevim esnasında işlenmesine gerek olmayan bir Kişisel Veri'ye erişimim olması durumunda
                bu erişimimin
                sonlandırılmasıyla ilgili derhal Fulla Moda ilgili Bilgi İşlem Müdürlüğünü bilgilendireceğimi,
              </p>

              <p>
                3.3.	Görevim esnasında temas ettiğim tüm kişisel verileri süresiz olarak gizli tutmayı,
                korumayı, üçüncü kişilerle herhangi bir şekilde paylaşmamayı ve/veya açıklamamayı, doğrudan ya
                da dolaylı olarak iş amaçları dışında kullanmamayı, şahsi çıkar amacıyla ya da mevzuata
                aykırı şekilde manipüle etmemeyi ve/ya herhangi bir ortama aktarmamayı, herhangi bir vasıta
                ile şirket dışına çıkartmamayı, iş amaçlı kullanım ile sınırlanan ve Fulla Moda tarafından
                şahsıma tahsis edilen bilgisayar ve e-posta dışında herhangi taşınabilir bir araç içerisine
                aktarmamayı, kopyalamamayı, çoğaltmamayı,
                bunlarla sınırlı olmaksızın başka herhangi bir amaçla erişime mümkün hale getirmemeyi,
              </p>

              <p>
                3.4.	Görevim gereğince Kişisel Veri'leri şirket içindeki yahut dışındaki kişilere aktarmaya veya
                paylaşmaya yetkili olmam veya Fulla Moda tarafından tarafıma böyle bir arızi yetki verilmesi
                halinde, söz konusu Kişisel Veri'leri yalnızca bilmesi gereken kişilere ve bilmeleri gerektiği
                kadarıyla aktarmayı veya paylaşmayı, bu kapsamın dışında kalan Kişisel Veri'leri ise aktarmamayı
                veya paylaşmamayı ve bu kapsam dışındaki Kişisel Veri'ler hariç tutulmaksızın aktarım veya paylaşım
                mümkün olmuyorsa aktarımı veya paylaşımı bu Kişisel Veri'leri karartarak gerçekleştirmeyi,
              </p>

              <p>
                3.5.	Görev alanımda olsun ya da olmasın, herhangi bir veri ihlali riski ile karşılaşmam halinde, Fulla Moda’yı derhal bilgilendirmeyi ve gecikmesinde sakınca olan hallerde ihlalin olası zararlarını ortadan kaldırmak için gerekli tüm önlemleri almayı,
              </p>

              <p>
                3.6.	Fulla Moda ile iş sözleşmemin herhangi bir sebeple sona ermesi halinde, kişisel veri içeren her türlü materyali, bilgisayar, tablet, akıllı telefon, depolama cihazları ve elektronik ortamda veya basılı olan tüm bilgi ve belgeleri derhal iade etmeyi,
              </p>

              <p>
                3.7.Kişisel verileri diğer çalışanlar da dâhil olmak üzere bu veriler ile ilgisi olmayan hiç kimse ile paylaşmamayı, elektronik ya da fiziksel ortamlarda muhafaza ettiğim kişisel verilerin ilgisiz veya yetkisiz kimsenin erişimine açık tutmamayı,
              </p>

              <p>
                3.8.Tarafıma bir iş başvurusu iletilmek istenmesi halinde bunları fiziksel ya da elektronik olarak kabul etmemeyi, talep etmememe rağmen kurumsal e-posta adresime veya benim kontrolümdeki diğer Fulla Moda bilgi sistemlerine bir iş başvurusu gelmesi halinde bunu ilgili birime iletmeksizin uygun şekilde imha etmeyi, kimseye ait özgeçmiş ya da benzer bir doküman saklamamayı, iş başvurusu yapmak isteyen kişileri doğrudan yetkili insan kaynakları departmanına yönlendirmeyi, işbu taahhütnamenin imza tarihi itibariyle mevcut olan tüm özgeçmişleri çevrim içi ve fiziksel ortamlardan imha etmeyi ya da edilmesini sağlamayı ve kurumsal e-posta hesabımı düzenli aralıklarla kontrol ederek (en geç 6 ayda bir) gereksiz olan e-postaları silmeyi,
              </p>

              <p>
                3.9.	Görevim esnasında yeni bir Kişisel Veri işleme faaliyetine başlanmasının söz konusu olması halinde, bu faaliyete başlamadan önce derhal Fulla Moda Bilgi İşlem ve Bilgi Güvenliği Departmanı ile iletişime geçerek söz konusu Kişisel Veri işleme faaliyetinin hukuka uygun şekilde gerçekleştirilmesini sağlamak için bilgi vermeyi ve olumlu görüş almadığım sürece bu faaliyetlere başlamamayı,
              </p>

              <p>
                3.10.	Kişisel veri içeren herhangi bir dokümanı paylaşmam hususunda Fulla Moda dışında üçüncü bir kişiden veya resmî kurumlardan talep gelmesi halinde yanıt vermeden önce ilgili birimi veya yetkiliyi bilgilendireceğimi, bu doğrultuda bana verilen talimata uygun hareket etmeyi,
              </p>

              <p>
                3.11.	Görevimin ifası esnasında özel nitelikli kişisel veriye (kişilerin ırkı, etnik kökeni, siyasi düşüncesi, felsefi inancı, dini, mezhebi veya diğer inançları, kılık ve kıyafeti, dernek, vakıf ya da sendika üyeliği, sağlığı, ceza mahkûmiyeti ve güvenlik tedbirleriyle ilgili verileri ile biyometrik ve genetik verileri) erişmem halinde özel nitelikli kişisel verilere ilişkin Fulla Moda  tarafından alınan ek önlemlere, prosedürlere ve verilen talimatlara riayet etmeyi ve görevimin ifası gerektirmedikçe hiçbir özel nitelikli kişisel veriye erişmemeyi ve bunları işlememeyi kabul, beyan ve taahhüt ederim.
              </p>

              <p>
                4.	İşbu taahhütnameye konu hususlar bakımından, Fulla Moda tarafından yayınlanan tüm kısıtlama, politika, prosedür, talimat ile bilgi güvenliği ile ilgili yapılan tüm duyuruları okuduğumu, anladığımı ve bunlara ve yayımlanacak olan her türlü politika, prosedüre uyacağımı, bu kurallarda yapılacak değişiklikleri takip edeceğimi ve bunlara da aynen uyacağımı kabul, beyan ve taahhüt ederim.
              </p>

              <p>
                5.	İşbu Taahhütnamenin, Fulla Moda ile akdettiğim iş sözleşmesinin ayrılmaz bir eki niteliğinde olduğunu; bu Taahhütname ile üstlenmiş olduğum yükümlülüklerin, Fulla Moda ile aramdaki iş ilişkisinin herhangi bir nedenle sona ermesinden veya ortadan kalkmasından sonra dahi süresiz olarak devam edeceğini, bu yükümlülüklere aykırı davranmam halinde, Fulla Moda’nın bu sebeple uğradığı veya uğrayacağı kar kaybı da dahil olmak üzere her türlü maddi ve manevi, doğrudan ve dolaylı zararlardan sorumlu olacağımı, Fulla Moda’nın disiplin yönetmeliği gereğince gerekli disiplin cezası uygulayabileceğini, bu yükümlülüklere aykırı hareket etmemin Fulla Moda ile akdettiğim iş sözleşmesinin esaslı nedenle ihlali teşkil edeceğini ve iş sözleşmemin haklı nedenle derhal sona erdirilebileceğini kabul, beyan ve taahhüt ederim.
              </p>

            </div>

            <div className="kvkk-popup-footer">
              <button
                type="button"
                className="kvkk-popup-onay-btn"
                onClick={handleKvkkPopupOnayla}
                disabled={!kvkkMetinOkundu}
              >
                Okudum, anladım ve onaylıyorum
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LegacyEgitimStep;